import React from 'react'
import styles from './index.module.css'
import PropTypes from 'prop-types'

const ExplicitTag = ({ size = 'default' }) => {
  const sizeStyles = {
    xsmall: styles.xsmall,
    small: styles.small,
    default: styles.default,
  }
  return <span className={`${styles.tag} ${sizeStyles[size]}`}>E</span>
}

ExplicitTag.propTypes = {
  size: PropTypes.oneOf(['xsmall', 'small', 'default']),
}
export default ExplicitTag
